module.exports = __webpack_public_path__ + "static/media/threeUp-general-liability.01c65105.png";